import { jwtDecode } from 'jwt-decode';
import { HandlerCollection, EventHandler } from '../Utils/mx-handler.collection';

interface Claims {
	exp: number;
	Role: string[];
	UserObjectId?: string;
	UserFragmentId?: string;
	'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
	OUID: string;
}

export class SessionModel {
	public raw: string;
	private expirationInterval?: NodeJS.Timeout;
	private readonly destroyHandlers = new HandlerCollection<boolean, void>();
	private claims: Claims;
	public restored = false;

	constructor(sessionToken: string) {
		this.raw = sessionToken;
		this.claims = this.initClaims();
		this.startExpirationCheck();
	}

	get expirationTime() {
		return this.claims.exp * 1000;
	}

	get ouID() {
		return this.claims.OUID;
	}

	public verify() {
		return !this.isExpired();
	}

	public destroy(isExpired = false) {
		if (this.expirationInterval) {
			clearInterval(this.expirationInterval);
			delete this.expirationInterval;

			this.destroyHandlers.execute(isExpired);
		}
	}

	public refresh(token: string) {
		this.raw = token;
		this.claims = this.initClaims();
	}

	public onDestroyed(handler: EventHandler<boolean, void>) {
		return this.destroyHandlers.add(handler);
	}

	private isExpired() {
		return this.expirationTime < Date.now();
	}

	private initClaims() {
		return jwtDecode(this.raw) as Claims;
	}

	private startExpirationCheck() {
		const intervalDelayInMilliseconds = 60 * 1000;

		this.expirationInterval = setInterval(() => {
			if (this.isExpired()) {
				this.destroy(true);
			}
		}, intervalDelayInMilliseconds);
	}
}
